import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const HeroSlider = ({ sliderData }) => {
  const [slides, setSlides] = useState(sliderData || null);
  const [loading,setLoading] =  useState(false)
  const [hydrating,setHydrating] = useState(true)
  const [error,setError] = useState(null)
  const [current, setCurrent] = useState(0);
  const autoTimer = useRef(null);
  const isFirstLoad = useRef(true);
  const location = useLocation().pathname




 

   useEffect(()  =>   {
 
       const hydrationTimer = setTimeout(() => {
          
             setHydrating(false)

       },300);


       return () => clearTimeout(hydrationTimer);

   },[])




  useEffect(() => {
   
    if (slides && isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }
   
    setLoading(true)

    const fetchData = async () => {
      try {
        const res = await fetch("https://teluguone.com/photos_api/photosBannersJson");
        if (!res.ok) throw new Error(`API Response Was Not Ok`)
        const data = await res.json();
        setSlides(data.photos_banners || '');
      
      } catch (e) {
        console.error("Fetch error:", e);
        setError(e.message)
      }finally {
         setLoading(false)
      }
    };

    fetchData();
  }, [slides]);




  const goTo = (n) => {
    setCurrent((prev) => {
      if (!slides?.length) return 0;
      return (n + slides.length) % slides.length;
    });
  };




  const resetTimer = () => {
    if (autoTimer.current) clearInterval(autoTimer.current);
    autoTimer.current = setInterval(() => {
      setCurrent((prev) =>
        slides?.length ? (prev + 1) % slides.length : 0
      );
    }, 3000);
  };


  


  useEffect(() => {
    if (!slides?.length) return;

    resetTimer();
    return () => clearInterval(autoTimer.current);
  }, [slides]);



  if (error) {

      return  <div className="hero-slider-wrap">
      <div className="hero-slider">

                  <div className="slide active">
               <Link to="">
                  <img src="/photos/assets/images/json_error.png" alt=""  style={{objectFit:"fill"}}/>
               </Link>
               <div className="slide-caption">
              <span className="slide-tag">Actress</span>
              <h2>
                <Link to="">No Data To Load</Link>
              </h2>
            </div>

        </div>

      </div>
        </div>
     
  }





  return (
    <div className="hero-slider-wrap">
      <div className="hero-slider">

      
      
        {(loading || hydrating) &&  <div className="slide">
               <Link to="">
                  <img src="/photos/assets/images/error_img.webp" alt="" />
               </Link>
               <div className="slide-caption">
              <span className="slide-tag">Actress</span>
              <h2>
                <Link to="">Loading...</Link>
              </h2>
            </div>

        </div>  }




        {slides && slides.map((item, i) => (
          <div
            key={i}
            className={`slide ${i === current ? "active" : ""} ${hydrating ?  'd-none' : ''}`}
          >
           
            <Link to={(item.url_link  ? item.url_link.substring(item.url_link.indexOf('/photos')+7) :""  )}>
              <img
                src={item.stimg ? item.stimg : ''}
                alt={item.title ? item.title : ''}
                loading={i === 0 ? "eager" : "auto"}
              />
            </Link>

            <div className="slide-caption">
              <span className="slide-tag">Actress</span>
              <h2>
                <Link to={(item.url_link  ? item.url_link.substring(item.url_link.indexOf('/photos')+7) :""  )} >{item.title ? item.title : ''}</Link>
              </h2>
            </div>
          </div>
        ))}
      </div>

      <button
        className="slider-btn prev"
        onClick={() => {
          goTo(current - 1);
          resetTimer();
        }}
      >
        &#10094;
      </button>

      <button
        className="slider-btn next"
        onClick={() => {
          goTo(current + 1);
          resetTimer();
        }}
      >
        &#10095;
      </button>

      <div className="slider-dots">
        {slides && slides.map((_, i) => (
          <button
            key={i}
            className={`dot ${i === current ? "active" : ""}`}
            onClick={() => {
              goTo(i);
              resetTimer();
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;